import { render, staticRenderFns } from "./EditRecipeIngredients.vue?vue&type=template&id=3e426b82&scoped=true"
import script from "./EditRecipeIngredients.vue?vue&type=script&lang=js"
export * from "./EditRecipeIngredients.vue?vue&type=script&lang=js"
import style0 from "./EditRecipeIngredients.vue?vue&type=style&index=0&id=3e426b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e426b82",
  null
  
)

export default component.exports